module.exports = __webpack_public_path__ + "static/media/Trakezie.c6c0ec33.png";